import CircularProgress from '@mui/material/CircularProgress'

export function PageLoader() {
  return (
    <div className="page-loader" role="status" aria-label="Загрузка">
      <CircularProgress aria-hidden color="success" size={40} thickness={3.6} />
    </div>
  )
}
